import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const TableToggleButton = ({ allOpen, toggleAllTablesState }) => {
  return (
    <button
      className="btn button"
      onClick={toggleAllTablesState}
    >
      {allOpen ? 'Összes becsukása' : 'Összes kinyitása'}
      <FontAwesomeIcon className="mx-1" icon={allOpen ? "fa-solid fa-chevron-up" : "fa-solid fa-chevron-down"} />
    </button>
  );
};

export default TableToggleButton;
